import React from 'react';

/**
 * DynamicStyledThemeProvider - Legacy compatibility wrapper
 *
 * This component previously provided styled-components ThemeProvider integration.
 * Since the codebase has been migrated to Tailwind CSS with CSS variables,
 * styled-components ThemeProvider is no longer needed.
 *
 * Theme values are now handled by:
 * - CSS variables defined in globals.css and design-tokens.css
 * - ThemeProvider context (providers/ThemeProvider) for dynamic values
 * - Tailwind CSS utilities that reference CSS variables
 *
 * This component is kept as a passthrough to maintain backwards compatibility
 * with the provider tree structure in contexts/index.tsx.
 *
 * @deprecated This component can be removed once contexts/index.tsx is refactored.
 */
const DynamicStyledThemeProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  // Simply pass through children - theme is now handled via CSS variables
  return <>{children}</>;
};

export default DynamicStyledThemeProvider;
